import { useContext } from 'react'

import { useUser } from '~/@biz_account/useUser/useUser'
import { type AllStepsData } from '../steps/AllStepsData'
import { useUnsophisticatedTestStore } from '../useUnsophisticatedTestStore'
import { FormStepContext } from './context'

export function useFormStepUnsophisticated() {
  const { user } = useUser()
  const { testData, updateTestData, goForward } = useUnsophisticatedTestStore(
    user?._id ?? null
  )
  const context = useContext(FormStepContext)

  if (!context) {
    throw new Error('FormStepContext.Provider is not initialized')
  }

  return {
    formData: testData ?? ({} as AllStepsData),
    onStepCompleted: (data: Parameters<typeof updateTestData>[0]) => {
      updateTestData(data)
      goForward()
    },
    onCompleted: (data: Parameters<typeof updateTestData>[0]) => {
      updateTestData(data)
      context.onCompleted(data)
    },
  }
}
